export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const NAME_REGEX = /^[a-zA-Z ]{2,40}$/;
export const PLAIN_TEXT_REGEX = /[a-zA-Z0-9!@#$%^&*()_+=-{}\[\]'";:<>.,/ ]{3,}$/;
export const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
